// Copyright (c) Move Closer 2022.

import { Injectable, IResponse, ResourceActionFailed } from '@movecloser/front-core'

import { IGraphQL } from '../../../../contexts'

import { resolveFromStatus } from '../../../../support'

import { CountryData, IDictionaryService } from './contracts'
import { shipmentAdapter } from './adapter'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
@Injectable()
export class Service implements IDictionaryService {
  public countries: CountryData[] = []
  protected graphQLConnector: IGraphQL

  constructor (graphQLConnector: IGraphQL) {
    this.graphQLConnector = graphQLConnector
  }

  /**
   * @inheritDoc
   */
  public async loadCountries (): Promise<void> {
    const response: IResponse = await this.graphQLConnector.call('countryQuery', {})

    if (!response.isSuccessful() && response.errors) {
      throw new ResourceActionFailed(
        response.errors[0].message,
        resolveFromStatus(response.status),
        response.data
      )
    }

    this.countries = shipmentAdapter(response.data.countries)
  }
}
